import React from "react";
import { Text, Button, PhoneNumberInput } from "components/common";

const PhoneNumberInputScreen = ({
  loading,
  errorMessage,
  titleText,
  handleSubmit = () => {},
  phoneNumber,
  setPhoneNumber = () => {},
}) => {
  return (
    <>
      <Text title className="mb-4 text-xl">{titleText}</Text>
      <PhoneNumberInput
        onChange={setPhoneNumber}
        onEnter={handleSubmit}
        value={phoneNumber}
        disabled={loading}
      />
      <div className="text-red-500 text-sm mt-2">{errorMessage}</div>
      <div>
        <Button
          type="button"
          className="mb-6 mt-5 text-xl btn-green px-16"
          disabled={loading}
          style={{
            backgroundColor: loading ? "gray" : "#26E3BA",
          }}
          onClick={handleSubmit}
          paddingHorizontal={64}
        >
          Submit
        </Button>
      </div>
    </>
  );
};

export default PhoneNumberInputScreen;